import React, { useEffect, useState } from "react";
import { PageHeader, Card, Typography, Tag, Button, Input, Select, notification } from 'antd';
import '../../styles/components/MarketPlace/CityWiseJobs.scss';
import { useHistory } from "react-router-dom";
import useGeoLocation from "../../hooks/useGeoLocation";
import {AimOutlined, SearchOutlined}  from '@ant-design/icons'
import BottomButton from "../Buttons/BottomButton";
import { getAllCities, updateMarketplaceUserDetails } from "../../services/API/MarketplaceService";
import { Routes } from "../../constants/RouterConstants";
import {Navigation} from "../../services/NavigationService";
import useMoengage from "../../hooks/useMoengage";
import moment from "moment";
import { useMitraStore } from "../../contexts/MitraContext";
import { useTranslation } from "react-i18next";

const {Text} = Typography;
const {Search} = Input;

const CityWiseJobs = () => {

    const history = useHistory();
    // const locationCoordinates = useGeoLocation();
    const [cityOptions, setCityOptions] = useState([]);
    const [selectedCity, setSelectedCity] = useState(undefined);
    const [open, setOpen] = useState(false);
    const [, trackEvent] = useMoengage();
    const { selectedMitraDetails } = useMitraStore();
    const {t, i18n} = useTranslation();

    const [cities, setCities] = useState([
        {id: 0, name:'Mumbai', isSelected: false},
        {id: 1, name:'Bengaluru', isSelected: false},
        {id: 2, name:'Pune', isSelected: false},
        {id: 3, name:'Chennai', isSelected: false},
        {id: 4, name:'New Delhi', isSelected: false},
        {id: 5, name:'Calcutta', isSelected: false},
        {id: 6, name:'Lucknow', isSelected: false},
        {id: 7, name:'Hyderabad', isSelected: false}
    ]);

    const [filteredCities, setFilteredCities] = useState(cityOptions);

    const onCitySelection = (cityId) => {
        const newCities = cities;

        for (let i=0;i<cities.length;i++){
            if (newCities[i].id === cityId){
                newCities[i].isSelected = true;
                setSelectedCity(newCities[i].name);
            } else {
                newCities[i].isSelected = false;
            }
        }

        setCities([...newCities]);
    };

    const goToJobListings = () => {
        if (!selectedCity) {
            notification['error']({
                message: t('city_required_ack')
              });
              return;
        }

        updateMarketplaceUserDetails({
        userId: localStorage.getItem('userId'),
        dataToUpdate: { jobseekerCityPreference: selectedCity },
        })
            .then(response => {
                trackEvent('jse_city_submission', 
                { 
                    userId: localStorage.getItem('userId'), 
                    userCity: selectedCity,
                    userPhoneNumber: selectedMitraDetails?.userPhoneNumber, 
                    timeStamp: moment().format('MM/DD/YYYY HH:mm:ss'),
             });
                localStorage.setItem('preferredLocation', selectedCity);
                const route = {
                    pathname: Routes.JOB_LISTINGS,
                    search: `city=${selectedCity}`
                };
                // history.replace(`/job-listings?city=${selectedCity}`);
                // const route = {
                //     pathname: Routes.FINDING_JOBS,
                //     search: `city=${selectedCity}`
                // };
                Navigation.push(route);
            })
            .catch(error => {
                console.log(error);
                localStorage.setItem('preferredLocation', selectedCity);

                const route = {
                    pathname: Routes.JOB_LISTINGS,
                    search: `city=${selectedCity}`
                };
                Navigation.push(route);
                // history.replace(`/job-listings?city=${selectedCity}`);
            })
    };

    useEffect(() => {
        getAllCities()
        .then(response=> {
            const cities = response.data.cities;
            const totalCities = cities.length;
            let cityData = [];

            for (let i=0;i<totalCities;i++){
                cityData = [...cityData, {value: i, label: cities[i]}];
            };

            setCityOptions([...cityData]);
            setFilteredCities([...cityData]);
        })
        .catch(error => console.log(error));
    }, [])
    

    // useEffect(() => {
        // if (location.loaded === true && location.coordinates){
        //     const google = window.google = window.google ? window.google : {}

        //     let latlng = new google.maps.LatLng(location.coordinates.lat, location.coordinates.lng);
        //     let address;
        //     // This is making the Geocode request
        //     let geocoder = new google.maps.Geocoder();
        //     geocoder.geocode({ 'latLng': latlng },  (results, status) =>{
        //         if (status !== google.maps.GeocoderStatus.OK) {
        //             alert(status);
        //         }
        //         // This is checking to see if the Geoeode Status is OK before proceeding
        //         if (status == google.maps.GeocoderStatus.OK) {
        //             console.log(results);
        //             address = (results[0].formatted_address);
        //         }
        //     });
        // }
    // }, [locationCoordinates]);

    const clearCityGridSection = () => {
        const newCities = cities;

        for (let i=0;i<cities.length;i++){
            newCities[i].isSelected = false;
        }
        setCities([...newCities]);
    }

    const onChange = (value) => {
        setSelectedCity(value);
        setOpen(false);
        clearCityGridSection();
      };

    const onSearch = (value) => {
        if (value === '') {
            setFilteredCities(cityOptions);
        }
        else {
            let filteredItems = cityOptions.filter(city => city.label.toLowerCase().includes(value.toLowerCase()));
            setFilteredCities([...filteredItems]);
        }
    };

    return (
        <div className="city-wise-jobs-main-container">
            <PageHeader className="site-page-header" title={t('city_selection_header')} />

            <div className="search-container">
                <Select
                    suffixIcon={<SearchOutlined />}
                    showSearch
                    style={{ width: '90%', margin:'0px 24px 0px 24px', borderRadius:'4px' }} 
                    placeholder={t('search_city')}
                    optionFilterProp="children"
                    onChange={onChange}
                    onSearch={onSearch}
                    // filterOption={(input, option) =>
                    // (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    // }
                    filterOption={true}
                    options={filteredCities}
                    value={selectedCity || undefined}
                    open={open}
                    onDropdownVisibleChange={(visible) => setOpen(visible)}
                    dropdownRender={
                        ()=>(
                        <div className="dropdown-content">{
                            filteredCities.map(city => {
                            return (
                            <div 
                            className="individual-city-container" 
                            onClick={()=>onChange(city.label)}
                            > 
                            <img src="/images/location-icon.png"/> 
                            <div className="city-details-container">
                                <Text className="city-label">{city.label}</Text>
                                {/* <Text className="city-details">Siraspur Road, Sector 18, New Delhi</Text> */}
                            </div>
                            </div>
                            )
                        })   
                        }</div>
                        )
                    }
                />
            </div>

            {/* <Text 
            className="location-detect-text"
            >
                <AimOutlined />
                Auto detect my location
            </Text> */}
            <div className="city-selection-container">
                <Text className="city-selection-header">Popular Cities</Text>
                <div className="city-container">
                    {
                        cities.map((city) => {
                            return <div key={city.id} onClick={()=> onCitySelection(city.id)} className={city.isSelected ? 'city selected' : 'city'}>{city.name}</div>
                        })
                    }
                </div>
            </div>
            <BottomButton  buttonText={t('proceed')} callBackFunction={goToJobListings}/>
        </div>
    )
};

export default CityWiseJobs;
